import { Component } from "@angular/core";

@Component({
  selector: "app-icon-red-circle",
  imports: [],
  templateUrl: "./icon-red-circle.component.html",
  styleUrl: "./icon-red-circle.component.scss",
})
export class IconRedCircleComponent {}
